<div class="embed-signup">
  @if (!submitted) {
    <div class="embed-signup__intro">
      <h2 class="embed-signup__heading">{{ config.headline || "Stay in the Know!" }}</h2>
      <p class="embed-signup__blurb" [innerHTML]="config.form_message || 'Get notified about upcoming livestreams and enter for a chance to win.' | safe: 'html'"></p>
      <form class="embed-signup__form" (submit)="submit($event)">
        <input class="embed-signup__input" type="email" name="signupEmail" [(ngModel)]="email" placeholder="Email address" autocomplete="email" aria-label="Email address" required />
        <div class="embed-signup__country" [class.has-selection]="countryCode" role="combobox" aria-haspopup="listbox" [attr.aria-expanded]="countryDropdownOpen">
          <input
            #countryInput
            class="embed-signup__input"
            type="text"
            name="signupCountry"
            autocomplete="off"
            aria-autocomplete="list"
            data-1p-ignore
            data-lpignore="true"
            data-form-type="other"
            placeholder="Country"
            aria-label="Country"
            [value]="countryQuery"
            [readonly]="!!countryCode"
            (input)="onCountryInput($event)"
            (focus)="openCountryDropdown()"
            (blur)="onCountryBlur()"
            (keydown)="onCountryKeydown($event)"
          />
          @if (countryCode) {
            <button type="button" class="embed-signup__country-clear" (click)="clearCountry()" aria-label="Clear country">&times;</button>
          }
          @if (countryDropdownOpen && filteredCountries.length) {
            <ul class="embed-signup__country-list" role="listbox" [ngStyle]="dropdownStyle">
              @for (country of filteredCountries; track country.code; let i = $index) {
                <li
                  [id]="'embed-country-opt-' + i"
                  class="embed-signup__country-option"
                  [class.is-highlighted]="i === highlightedIndex"
                  role="option"
                  [attr.aria-selected]="country.code === countryCode"
                  (mousedown)="$event.preventDefault()"
                  (click)="selectCountry(country)"
                  (mouseenter)="highlightedIndex = i"
                >
                  {{ country.title }}
                </li>
              }
            </ul>
          }
        </div>
        <label class="embed-signup__optin">
          <input type="checkbox" name="signupOptIn" [(ngModel)]="marketingOptIn" />
          <span>{{ config.optin_message || "Yes, send me Fender news, offers, and updates by email." }}</span>
        </label>
        @if (error) {
          <p class="embed-signup__error">{{ error }}</p>
        }
        <button type="submit" class="embed-signup__cta" [disabled]="submitting">{{ submitting ? "Submitting…" : config.submit_button_text || "Sign Up" }}</button>
      </form>
      <!-- Legal note: admin-configurable per state (HTML); falls back to the localized default. -->
      <p class="embed-signup__legal" [innerHTML]="config.legal_disclaimer || ('events.signup_legal' | translate)"></p>
    </div>
  } @else {
    <div class="embed-signup__intro embed-signup__intro--done">
      <h2 class="embed-signup__heading">{{ config.success_header || "You're in!" }}</h2>
      <p class="embed-signup__blurb">{{ config.success_message || "Thanks for signing up — we'll let you know about upcoming livestreams." }}</p>
    </div>
  }
</div>
